import styled from "styled-components";

export const AppSettingsWrap = styled.div`
  .settings-section {
    margin-bottom: 30px;
    padding: 20px;
    border: 1px solid #efefef;
    border-radius: 12px;
    background: #fafafa;
  }

  .settings-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    display: block;
    color: #333;
  }

  .setting-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    .info {
      flex: 1;
      padding-right: 20px;

      strong {
        display: block;
        font-size: 16px;
        margin-bottom: 4px;
        color: #444;
      }

      p {
        font-size: 14px;
        color: #777;
        margin: 0;
      }
    }
  }
`;
